"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocUploaderModal = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./UploaderModal.css"));
var DocUploader_1 = require("./DocUploader");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DocUploaderModal = function (_a) {
    var onClose = _a.onClose, props = __rest(_a, ["onClose"]);
    return (react_1.default.createElement(kaleidoscope_1.Layer, null, function () { return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.modalOuter },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.modalContainer },
            react_1.default.createElement(ModalHeader, { onClose: onClose }),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.modalBody },
                react_1.default.createElement(DocUploader_1.DocUploader, __assign({}, props)))))); }));
};
exports.DocUploaderModal = DocUploaderModal;
var ModalHeader = function (_a) {
    var onClose = _a.onClose;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.modalHeader, direction: "horizontal", align: "center", justify: "spaceBetween", padding: "m" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", align: "center" },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.iconFrame, justify: "center", align: "center" },
                react_1.default.createElement(icons_1.Upload, { color: "primary" })),
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Upload your Doc")),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "m", align: "center" },
            react_1.default.createElement(kaleidoscope_1.Text, null, "Use our AI-powered upload to make easier to get started"),
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), isIconOnly: true, onClick: onClose }))));
};
